function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable class-methods-use-this */
import { getOrThrow } from '@deephaven/utils';
import GridModel from "./GridModel.js";
import GridTheme from "./GridTheme.js";
var DEFAULT_AXIS = 'proportional';
var DEFAULT_POSITIVE_COLOR = GridTheme.positiveBarColor;
var DEFAULT_NEGATIVE_COLOR = GridTheme.negativeBarColor;
var DEFAULT_VALUE_PLACEMENT = 'beside';
var DEFAULT_DIRECTION = 'LTR';
var DEFAULT_TEXT_ALIGNMENT = 'right';
function isArrayOfNumbers(value) {
  return Array.isArray(value) && value.every(item => typeof item === 'number');
}
class MockDataBarGridModel extends GridModel {
  constructor(data) {
    var columnAxes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
    var positiveColors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Map();
    var negativeColors = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Map();
    var valuePlacements = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new Map();
    var opacities = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new Map();
    var directions = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : new Map();
    var textAlignments = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : new Map();
    var markers = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : new Map();
    super();
    _defineProperty(this, "numberOfColumns", void 0);
    _defineProperty(this, "numberOfRows", void 0);
    _defineProperty(this, "data", void 0);
    _defineProperty(this, "columnMins", void 0);
    _defineProperty(this, "columnMaxs", void 0);
    _defineProperty(this, "columnAxes", void 0);
    _defineProperty(this, "valuePlacements", void 0);
    _defineProperty(this, "directions", void 0);
    _defineProperty(this, "positiveColors", void 0);
    _defineProperty(this, "negativeColors", void 0);
    // Opacities should be between 0 and 1
    _defineProperty(this, "opacities", void 0);
    _defineProperty(this, "textAlignments", void 0);
    _defineProperty(this, "markers", void 0);
    this.positiveColors = positiveColors;
    this.negativeColors = negativeColors;
    this.data = data;
    this.columnAxes = columnAxes;
    this.valuePlacements = valuePlacements;
    this.opacities = opacities;
    this.directions = directions;
    this.textAlignments = textAlignments;
    this.markers = markers;
    this.numberOfRows = Math.max(...data.map(row => row.length));
    this.numberOfColumns = data.length;
    this.columnMins = new Map();
    this.columnMaxs = new Map();
    for (var i = 0; i < data.length; i += 1) {
      var column = data[i];
      if (isArrayOfNumbers(column)) {
        this.columnMins.set(i, Math.min(...column));
        this.columnMaxs.set(i, Math.max(...column));
      }
    }
  }
  get rowCount() {
    return this.numberOfRows;
  }
  get columnCount() {
    return this.numberOfColumns;
  }
  textForCell(column, row) {
    var _this$data$column;
    return "".concat((_this$data$column = this.data[column]) === null || _this$data$column === void 0 ? void 0 : _this$data$column[row]);
  }
  textForColumnHeader(column) {
    return "".concat(column);
  }
  textAlignForCell(column, row) {
    var _this$textAlignments$;
    return (_this$textAlignments$ = this.textAlignments.get(column)) !== null && _this$textAlignments$ !== void 0 ? _this$textAlignments$ : DEFAULT_TEXT_ALIGNMENT;
  }
  renderTypeForCell(column, row) {
    if (column < 20) {
      return 'dataBar';
    }
    return column % 2 === row % 2 ? 'dataBar' : 'text';
  }
  dataBarOptionsForCell(column, row) {
    var _this$columnAxes$get, _this$valuePlacements, _this$directions$get, _this$positiveColors$, _this$negativeColors$, _this$data$column2, _this$markers$get;
    var columnMin = getOrThrow(this.columnMins, column);
    var columnMax = getOrThrow(this.columnMaxs, column);
    var axis = (_this$columnAxes$get = this.columnAxes.get(column)) !== null && _this$columnAxes$get !== void 0 ? _this$columnAxes$get : DEFAULT_AXIS;
    var valuePlacement = (_this$valuePlacements = this.valuePlacements.get(column)) !== null && _this$valuePlacements !== void 0 ? _this$valuePlacements : DEFAULT_VALUE_PLACEMENT;
    var opacity = this.opacities.get(column);
    if (opacity == null || opacity > 1) {
      opacity = 1;
    } else if (opacity < 0) {
      opacity = 0;
    }
    var direction = (_this$directions$get = this.directions.get(column)) !== null && _this$directions$get !== void 0 ? _this$directions$get : DEFAULT_DIRECTION;
    var positiveColor = (_this$positiveColors$ = this.positiveColors.get(column)) !== null && _this$positiveColors$ !== void 0 ? _this$positiveColors$ : DEFAULT_POSITIVE_COLOR;
    var negativeColor = (_this$negativeColors$ = this.negativeColors.get(column)) !== null && _this$negativeColors$ !== void 0 ? _this$negativeColors$ : DEFAULT_NEGATIVE_COLOR;
    var value = Number((_this$data$column2 = this.data[column]) === null || _this$data$column2 === void 0 ? void 0 : _this$data$column2[row]);
    var color = value >= 0 ? positiveColor : negativeColor;
    var markers = (_this$markers$get = this.markers.get(column)) !== null && _this$markers$get !== void 0 ? _this$markers$get : [];
    var hasGradient = Array.isArray(color) && color.length > 1;
    var textColor;
    if (hasGradient) {
      textColor = value >= 0 ? color[color.length - 1] : color[0];
    } else {
      textColor = Array.isArray(color) ? color[0] : color;
    }
    return {
      columnMin,
      columnMax,
      axis,
      color,
      textColor,
      valuePlacement,
      opacity,
      markers,
      direction,
      value
    };
  }
}
export default MockDataBarGridModel;
//# sourceMappingURL=MockDataBarGridModel.js.map